import moment from "moment";

export const HOLIDAY_DATE_FORMAT = "MMM D, YYYY";

export const startOfDay = (value) => {
	if (!value) return null;

	const date = new Date(value);

	if (isNaN(date.getTime())) return null;

	date.setHours(0, 0, 0, 0);

	return date;
};

export const formatHolidayDate = (value) => {
	const date = startOfDay(value);

	if (!date) return "";

	return moment(date).format(HOLIDAY_DATE_FORMAT);
};

export const getHolidayDuration = (holiday) => {
	const start = startOfDay(holiday?.startDate);
	const end = startOfDay(holiday?.endDate);

	if (!start) return 1;
	if (!end || end <= start) return 1;

	return moment(end).diff(moment(start), "days") + 1;
};

export const isMultiDayHoliday = (holiday) => getHolidayDuration(holiday) > 1;

export const formatDuration = (days) => days + (days === 1 ? " day" : " days");

export const formatHolidayCount = (total) => total + (total === 1 ? " holiday" : " holidays");

export const formatYearCount = (total) => total + (total === 1 ? " year" : " years");

export const sortHolidays = (holidays) => {
	return [...(holidays || [])].sort((a, b) => {
		const start = new Date(a.startDate || 0) - new Date(b.startDate || 0);

		if (start) return start;

		return (a.title || "").localeCompare(b.title || "");
	});
};

export const filterHolidays = (holidays, keyword) => {
	const trimmed = (keyword || "").trim().toLowerCase();

	if (!trimmed) return holidays;

	return holidays.filter((o) => (o.title || "").toLowerCase().includes(trimmed));
};

export const groupCalendarsByRegion = (records) => {
	const groups = new Map();

	(records || []).forEach((record) => {
		const regionCode = record.regionCode;

		if (!regionCode) return;

		if (!groups.has(regionCode)) groups.set(regionCode, []);

		groups.get(regionCode).push(record);
	});

	const calendars = [...groups.entries()].map(([regionCode, years]) => {
		const sorted = [...years].sort((a, b) => b.year - a.year);
		const latest = sorted[0];

		return {
			regionCode,
			years: sorted,
			region: latest.region || "",
			title: latest.title || regionCode,
			yearCount: sorted.length,
			holidayCount: sorted.reduce((total, o) => total + (o.holidays?.length || 0), 0),
		};
	});

	return calendars.sort((a, b) => a.title.localeCompare(b.title));
};

export const findCalendarByRegionCode = (records, regionCode) => {
	if (!regionCode) return null;

	return groupCalendarsByRegion(records).find((o) => o.regionCode === regionCode) || null;
};
